
export class RequestFormExtended {
    ApplicationForm: ApplicationForm = new ApplicationForm();
    BiospecimenRequests: BiospecimenRequest[] = [];
}

export class ApplicationForm {
    Id: number = 0;
    RequestStatusId: number = 1;
    SubmissionDate: Date = new Date(1, 1, 1);
    LastUpdated: Date = new Date(1, 1, 1);
    UserId: number = 0;

    //Contact Information
    RequestorFirstName: string = "";
    RequestorLastName: string = "";
    InstitutionName: string = "";
    InstitutionTypeId: number = 0;
    InstitutionTypeOther: string = "";
    RequestorTelephone: string = "";
    RequestorEmail: string = "";

    //Letter of Support Details:
    LetterAddressedTo: string = "";
    LetterNeededByDate: Date = new Date(1, 1, 1);

    //Project Details:
    ProjectTitle: string = "";
    ProjectShortTitle: string = "";
    PINames: string = "";
    CollaboratingInvestigators: string = "";
    ExpertiseNeeded: string = "";
    Background: string = "";
    ScientificAims: string = "";
    Hypothesis: string = "";
    RationaleImpact: string = "";
    Methods: string = "";
    SampleSizePowerAnalysisApproach: string = "";
    ParticipantDescription: string = "";
    AssayDescription: string = "";

    //Biostatician Support:
    BiostatisticianSupportType: string = ""; 
    BiostatisticianSupportId: number = 0;
    BiostatisticianSupportOther: string = "";
    RelevantLiteratureReferences: string = "";

    //Admin Details:
    SharingPlan: string = "";
    BiospecimenUsageAbility: string = "";
    StartDate: Date = new Date(1, 1, 1);
    CompletionDate: Date = new Date(1, 1, 1);
    HasExternalCollaboratorsId: number = 0;
    ExternalCollaboratorsComment: string = "";
    FundingStatusId: number = 0;
    FundingSources: string = "";

    //Request History:
    HasPreviousRequestId: number = 0;
    NewOrResubmittedRequestId: number = 0;

    //Engagement:
    EngagementPlans: string = "";

    constructor() { }
}

export class BiospecimenRequest {
    Id: number = 0;
    BiospecimenRequestName: string = "";
    ClinicalTrialId: number = 0;
    BiospecimenTypeId: number = 0;
    TreatmentArmId: number = 0;
    SymptomClusterId: number = 0;
    VisitIds: string = "";
    QueryIds: string = "";
    Quantity: string = "";
    Volume: string = "";
    UnitId: number = 0;
    ApplicationFormId: number = 0;

    constructor() { }
}

export class StudyGroup {
    StudyId: number;
    TreatmentIds: number[];
    SymptomClusterIds: number[];
    SpecimenTypeIds: number[];
    VisitIds: number[];
    UnitMeasureIds: number[];
    constructor() {

    }
}

export class UserQuery {
    Id: number;
    QueryName: string;
    QueryJson: string;
    HumanReadable: string;
}